module.exports = __webpack_public_path__ + "img/bg-audio-6.7aab4b09.png";